import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { events } from "../data/events-data";
import "../App.css";

const Events = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const [showPast, setShowPast] = useState(false);

  /* Helper to switch language-specific fields */
  const get = (item, field) =>
    i18n.language === "ar" ? item[`${field}_ar`] : item[`${field}_en`];

  const filtered = events.filter((e) => e.isPast === showPast);

  return (
    <main
      className={`container ${isRTL ? "arabic-font" : ""}`}
      style={{ direction: isRTL ? "rtl" : "ltr" }}
    >
      <h1 className="storybook-heading">{t("eventsTitle")}</h1>

      {/* Toggle buttons */}
      <div className="button-group" style={{ marginBottom: "1.5rem" }}>
        <button
          className={`btn ${!showPast ? "" : "grey-btn"}`}
          onClick={() => setShowPast(false)}
        >
          {t("eventsUpcoming")}
        </button>
        <button
          className={`btn ${showPast ? "" : "grey-btn"}`}
          onClick={() => setShowPast(true)}
        >
          {t("eventsPast")}
        </button>
      </div>

      {/* Events grid */}
      <div
        style={{
          display: "grid",
          gap: "1.5rem",
          gridTemplateColumns: "repeat(auto-fit,minmax(280px,1fr))",
        }}
      >
        {filtered.length === 0 && (
          <p>{t("eventsNone")}</p>
        )}

        {filtered.map((ev) => (
          <div key={ev.id} className="card">
            <h3 style={{ color: "#F4888C" }}>{get(ev, "title")}</h3>
            <p style={{ fontWeight: 600 }}>{ev.date}</p>
            <p>{get(ev, "location")}</p>
            <p style={{ color: "#4b5563" }}>{get(ev, "desc")}</p>
            {ev.registerLink && !ev.isPast && (
              <a
                className="btn"
                href={ev.registerLink}
                target="_blank"
                rel="noreferrer"
              >
                {t("eventsRegister")}
              </a>
            )}
          </div>
        ))}
      </div>
    </main>
  );
};

export default Events;
